export default __webpack_public_path__ + "media/images/logo_alt-6090911445f54a587465e41da77a6969.svg";